import React, { useEffect } from "react";
import { useState } from "react";
import { Input, Radio, Select, Space, Form, Button, notification, message } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import staffRequest from "../StaffRequest";
import RoleRequest from "../Role/RoleRequest";
import { Option } from "antd/es/mentions";
import { usePermission } from "../../../hooks/usePermission";
import { GetLoggedInUser } from "../../../utils/utils";

export const AddUser = () => {
  const permission = usePermission("Users", "Add");
  let LOG_IN_USER = GetLoggedInUser();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [fileList, setFileList] = useState([])
  const [roleDetails, setRoleDetails] = useState([]);
  console.log(roleDetails, 'role')
  const onFinish = (values) => {
    console.log(values)
    setLoading(true)
    const allFormData = { ...values }
    console.log(allFormData);
    staffRequest.createStaff(allFormData)
      .then((res) => {
        if (res.status === 201) {
          notification.success({
            message: "User added successfully"
          })
          navigate(-1)
        } else {

          notification.error({
            message: "Something went wrong"
          })
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add user",
        });
        console.error("API Error:", e);
      });
  }

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const handleSubmit = () => {
    form.submit(); // Trigger form validation and submission
  };
  const fetchRoleList = () => {
    setLoading(true);
    RoleRequest.roleList({ page: 1 })
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData)

        setRoleDetails(rawData);

      })
      .catch((error) => {
        message.error("Failed to fetch user list")
        console.log("error", error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchRoleList();
  }, [])

  
  return (
    <>
      <section>
        <div className="Create-Category">

          <Form.Item className="submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Add User</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            {/* First Row */}
            <div className="subscription">
              <Form.Item
                name="name"
                label="Name"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the user name!" },
                  { pattern: /^[A-Za-z\s]+$/, message: "User name can only contain alphabetic characters!" },
                ]}
              >
                <Input size="large" placeholder="Enter User Name" />
              </Form.Item>

              <Form.Item
                name="email"
                label="Email"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input size="large" placeholder="Enter User Email" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="mobile"
                label="Number"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the mobile number!" },
                  { pattern: /^[0-9]{10}$/, message: "Mobile number must be exactly 10 digits!" },
                ]}
              >
                <Input size="large" placeholder="Enter User Number" />
              </Form.Item>

              <Form.Item
                name="role"
                label="Role"
                className="subscription-plan"
                rules={[{ required: true, message: "Please select the role!" }]}
              >
                <Select
                  placeholder="Select The role"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={handleChange}
                >
                  {roleDetails?.length > 0 &&
                    roleDetails?.map((item, idx) => (
                      <Option
                        key={idx}
                        className="text-capitalize"
                        value={item?.roleId}
                      >
                        {item?.roleTitle}
                      </Option>
                    ))}

                </Select>
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="password"
                label="Password"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the password!" },
                  {
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    message: "Password must be at least 8 characters, include one uppercase letter, one lowercase letter, one number, and one special character!",
                  },
                ]}
              >
                <Input.Password size="large" placeholder="Enter The Password" />
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save & Proceed
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
